import React from "react";
import { Card, CardBody, Row, Col } from "reactstrap";
import { BsFillPencilFill, BsTrash } from "react-icons/bs";
import { HIGHLIGHT_TYPE } from "../../configs/constants";
import { getGridLineColor } from '../../helpers/utils'

function isOfferStr (value) {
  switch (value) {
    case HIGHLIGHT_TYPE.blink:
      return "Pisca";
    case HIGHLIGHT_TYPE.club:
      return "Clube";
    case HIGHLIGHT_TYPE.offer:
      return "Oferta";
    default: 
      return "Nenhum";
  }
}

const HangtagCard = ({
  productCode,
  productName,
  productValue,
  highlightType,
  originalValue,
  clubValue,
  index,
  onClick,
  onDelete
}) => (
  <Card style={{ cursor: "pointer", marginBottom: "0px"  }} className="card-chart">
    <CardBody style={{padding: "8px", paddingLeft: "5px", backgroundColor: (index % 2 === 0 ? "inherit" : getGridLineColor())}}>
      <Row>
        <Col xs={4} md={2} style={{display: "flex", alignItems: "center"}}>
          {productCode}
        </Col>
        <Col xs={4} md={5} style={{display: "flex", alignItems: "center"}}>
          {productName}
        </Col>       
        <Col md={1} style={{display: "flex", alignItems: "center"}} className="display-none-xs">
          {isOfferStr(highlightType)}
        </Col>        
        <Col md={2} style={{display: "flex", alignItems: "center"}} className="display-none-xs">
          {highlightType === HIGHLIGHT_TYPE.offer ? originalValue : highlightType === HIGHLIGHT_TYPE.club ? clubValue : productValue}
        </Col>
        <Col xs={4} md={2} style={{display: "flex", justifyContent: "flex-end", alignItems: "center"}}>
          <BsTrash
            onClick={onDelete}
            className="icon-xs"
            title="Deletar"
            size= {20}
            color="#ec250d"
          /> 
          <BsFillPencilFill              
              size= {20}
              className="icon-xs"
              style={{marginLeft: "5px", marginRight: "5px"}}
              title="Editar"
              onClick={onClick}
              color="#4cd678"
          />
        </Col>
      </Row>
    </CardBody>
  </Card>
);

export default HangtagCard;
